// extracted by css-extract-rspack-plugin
export default {"event":"event--TjQGJPUjbEsPGJA9","eventDate":"event-date--gSp3ZdaqcQzyo0SY","eventContent":"event-content--KIKE3KPJ6d0vWLNG"};